import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getRemainingTime, getMiddleColor } from '../../NFThelper';
import Style from './DropTimer.module.scss';

const DropTimeEntry = React.memo(({ background = '', title = '', value = 0 }) => (
  <div className={Style.dropTimeEntry} style={{ background }}>
    <div className={Style.dropTimeValue}>{`${value < 10 ? '0' : ''}${value < 0 ? 0 : value}`}</div>
    <div className={Style.dropTimeTitle}>{title}</div>
  </div>
));

const DropTimer = ({
  dropTime = '',
  endColor = '#832376',
  isDropActive = false,
  setIsDropActive = () => {},
  setIsSameDay = () => {},
  startColor = '#2F2B82',
}) => {
  const initTimeRemaining = getRemainingTime(dropTime);
  const [days, setDays] = useState(initTimeRemaining?.days);
  const [hours, setHours] = useState(initTimeRemaining?.hours);
  const [minutes, setMinutes] = useState(initTimeRemaining?.minutes);
  const [seconds, setSeconds] = useState(initTimeRemaining?.seconds);
  const [counter, setCounter] = useState(initTimeRemaining?.total);

  useEffect(() => {
    let intervalId;
    if (days === 0) setIsSameDay(true);
    if (counter > -1) {
      intervalId = setInterval(() => {
        const timeRemaining = getRemainingTime(dropTime);
        setDays(timeRemaining?.days);
        setHours(timeRemaining?.hours);
        setMinutes(timeRemaining?.minutes);
        setSeconds(timeRemaining?.seconds);
        setCounter(timeRemaining?.total);
      }, 1000);
    } else {
      setIsDropActive(true);
    }
    return () => clearInterval(intervalId);
  }, [counter]);
  if (isDropActive) return null;
  const getBackground = (hexColor1, hexColor2, percentage) =>
    `linear-gradient(-180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%),
    linear-gradient(90deg, ${hexColor1}, ${hexColor2} ${percentage}%)`;
  const middleColor = getMiddleColor(startColor, endColor);
  return (
    <div className={Style.dropTimer}>
      <div className={Style.timerContainer}>
        <DropTimeEntry
          background={getBackground(startColor, startColor, 100)}
          title="Days"
          value={days}
        />
        <DropTimeEntry
          background={getBackground(startColor, endColor, 200)}
          title="Hours"
          value={hours}
        />
        <DropTimeEntry
          background={getBackground(middleColor, endColor, 100)}
          title="Minutes"
          value={minutes}
        />
        <DropTimeEntry
          background={getBackground(startColor, endColor, 0)}
          title="Seconds"
          value={seconds}
        />
      </div>
    </div>
  );
};

DropTimeEntry.propTypes = {
  background: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.number,
};

DropTimer.propTypes = {
  dropTime: PropTypes.string,
  endColor: PropTypes.string,
  isDropActive: PropTypes.bool,
  setIsDropActive: PropTypes.func,
  setIsSameDay: PropTypes.func,
  startColor: PropTypes.string,
};

export default DropTimer;
